import { z } from 'zod';

export const getIdProtectResponseSchema = z.object({
  costPerMonth: z.object({ value: z.number(), type: z.literal('AMOUNT') })
});

export const getPaymentProtectionInsuranceResponseSchema = z.object({
  costPerMonth: z.object({ value: z.number(), type: z.literal('RATE') })
});
